import React, { useContext, useEffect, useState } from "react";
import { DarkModeContext } from "../../context/DarkModeContext";
import Footer from "../../components/comunes/Footer";
import { useNavigate } from "react-router-dom";
import { getToken } from "../../utils/auth";
import { Spinner, Badge } from "react-bootstrap";

const AZUL_META = "#1877F2";
const ESTADOS_LABEL = {
    nuevo: { label: "Nuevos", color: "#1877F2" },
    contactado: { label: "Contactados", color: "#f0a500" },
    en_seguimiento: { label: "En seguimiento", color: "#17a2b8" },
    cerrado: { label: "Cerrados", color: "#28a745" },
    sin_interes: { label: "Sin interés", color: "#6c757d" },
};

const MetaInicio = () => {
    const { darkMode } = useContext(DarkModeContext);
    const navegacion = useNavigate();
    const [cargando, setCargando] = useState(true);
    const [leads, setLeads] = useState([]);
    const [loadingLeads, setLoadingLeads] = useState(true);

    useEffect(() => {
        const verificar = async () => {
            const token = getToken();
            if (!token) { navegacion("/"); return; }
            try {
                const r = await fetch(process.env.REACT_APP_API_TOKEN, {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({ Token: token }),
                });
                if (!r.ok) navegacion("/");
            } catch { navegacion("/"); }
            finally { setCargando(false); }
        };
        verificar();
    }, [navegacion]);

    useEffect(() => {
        const cargar = async () => {
            try {
                const r = await fetch(process.env.REACT_APP_API_META_LEADS);
                if (!r.ok) return;
                const data = await r.json();
                setLeads(data);
            } catch {}
            finally { setLoadingLeads(false); }
        };
        cargar();
    }, []);

    if (cargando) return null;

    const conteo = Object.keys(ESTADOS_LABEL).reduce((acc, k) => {
        acc[k] = leads.filter(l => l.estado === k).length;
        return acc;
    }, {});
    const total = leads.length;
    const ultimos = [...leads].sort((a, b) => new Date(b.fechaRecibido) - new Date(a.fechaRecibido)).slice(0, 5);

    const cardStyle = {
        borderRadius: 12,
        padding: "18px 22px",
        background: darkMode ? "#2c2f36" : "#fff",
        boxShadow: "0 2px 10px rgba(0,0,0,0.08)",
        border: `1px solid ${darkMode ? "#3d4148" : "#e9ecef"}`,
    };

    return (
        <div className={darkMode ? "bg-dark text-white min-vh-100" : "bg-light min-vh-100"}>
            {/* Header */}
            <div style={{ background: AZUL_META, padding: "20px 28px", color: "#fff" }}>
                <div className="d-flex align-items-center gap-3">
                    <svg width="32" height="32" viewBox="0 0 24 24" fill="white">
                        <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                    </svg>
                    <div>
                        <h4 className="mb-0 fw-bold">Panel Meta</h4>
                        <small style={{ opacity: 0.85 }}>Facebook & Instagram Lead Ads</small>
                    </div>
                </div>
            </div>

            <div className="container-fluid py-4 px-4">
                {/* KPIs */}
                {loadingLeads ? (
                    <div className="text-center py-4"><Spinner animation="border" /></div>
                ) : (
                    <>
                        <div className="row g-3 mb-4">
                            <div className="col-6 col-md-2">
                                <div style={{ ...cardStyle, borderTop: `4px solid ${AZUL_META}` }}>
                                    <div style={{ fontSize: 28, fontWeight: 700, color: AZUL_META }}>{total}</div>
                                    <div style={{ fontSize: 13, color: darkMode ? "#aaa" : "#666" }}>Total leads</div>
                                </div>
                            </div>
                            {Object.entries(ESTADOS_LABEL).map(([k, v]) => (
                                <div className="col-6 col-md-2" key={k}>
                                    <div style={{ ...cardStyle, borderTop: `4px solid ${v.color}` }}>
                                        <div style={{ fontSize: 28, fontWeight: 700, color: v.color }}>{conteo[k] || 0}</div>
                                        <div style={{ fontSize: 13, color: darkMode ? "#aaa" : "#666" }}>{v.label}</div>
                                    </div>
                                </div>
                            ))}
                        </div>

                        {/* Últimos leads */}
                        <div style={cardStyle}>
                            <h6 className="fw-bold mb-3">Últimos 5 leads recibidos</h6>
                            {ultimos.length === 0 ? (
                                <p className="text-muted" style={{ fontSize: 13 }}>No hay leads aún.</p>
                            ) : (
                                <table className="table table-sm" style={{ fontSize: 13 }}>
                                    <thead>
                                        <tr>
                                            <th>Fecha</th>
                                            <th>Nombre</th>
                                            <th>Teléfono</th>
                                            <th>Email</th>
                                            <th>Estado</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {ultimos.map(l => (
                                            <tr key={l.id}>
                                                <td>{new Date(l.fechaRecibido).toLocaleDateString("es-AR")}</td>
                                                <td>{l.nombre || "-"}</td>
                                                <td>{l.telefono || "-"}</td>
                                                <td>{l.email || "-"}</td>
                                                <td>
                                                    <Badge bg={estadoBadge(l.estado)}>{l.estado}</Badge>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            )}
                        </div>
                    </>
                )}
            </div>
            <Footer />
        </div>
    );
};

function estadoBadge(estado) {
    const map = { nuevo: "primary", contactado: "warning", en_seguimiento: "info", cerrado: "success", sin_interes: "secondary" };
    return map[estado] || "light";
}

export default MetaInicio;
